module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.projectDetail.status === 'participation') ? _c('div', {
    staticClass: "myProjectDetail"
  }, [_c('mt-header', {
    attrs: {
      "title": _vm.projectDetail.project.title
    }
  }, [_c('mt-button', {
    attrs: {
      "slot": "left",
      "icon": "back"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    },
    slot: "left"
  }, [_vm._v("返回")])], 1), _vm._v(" "), (_vm.projectDetail.status === 'projectOffer') ? _c('div', {
    staticClass: "letter"
  }, [_c('p', {
    staticClass: "letter_title"
  }, [_vm._v("我申请了这个项目")]), _vm._v(" "), _c('h1', [_vm._v("申请信")]), _vm._v(" "), _c('p', {
    staticClass: "letter_money"
  }, [_vm._v("我的报价： ¥"), _c('strong', [_vm._v(_vm._s(_vm.projectDetail.projectOffer.price))]), _vm._v("元")]), _vm._v(" "), _c('pre', [_vm._v("      " + _vm._s(_vm.projectDetail.projectOffer.content) + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "step"
  }, [_c('div', {
    class: {
      'classSelect': _vm.projectDetail.project.participationstatus == 0 || _vm.projectDetail.project.participationstatus == 1 || _vm.projectDetail.project.participationstatus == 2 || _vm.projectDetail.project.participationstatus == 4
    }
  }, [_c('p', [_c('icon', {
    staticClass: "icon",
    attrs: {
      "name": "globe"
    }
  })], 1), _vm._v(" 达成合作并托管资金 "), _c('span')]), _c('div', {
    class: {
      'classSelect': _vm.projectDetail.project.participationstatus == 1 || _vm.projectDetail.project.participationstatus == 2 || _vm.projectDetail.project.participationstatus == 4
    }
  }, [_c('span'), _vm._v(" "), _c('p', [_c('icon', {
    staticClass: "icon",
    attrs: {
      "name": "handshake-o"
    }
  })], 1), _vm._v(" 执行中 "), _c('span')]), _c('div', {
    class: {
      'classSelect': _vm.projectDetail.project.participationstatus == 2 || _vm.projectDetail.project.participationstatus == 4
    }
  }, [_c('span'), _vm._v(" "), _c('p', [_c('icon', {
    staticClass: "icon",
    attrs: {
      "name": "hourglass-half"
    }
  })], 1), _vm._v(" 交付待验收 "), _c('span')]), _c('div', {
    class: {
      'classSelect': _vm.projectDetail.project.participationstatus == 4
    }
  }, [_c('span'), _vm._v(" "), _c('p', [_c('icon', {
    staticClass: "icon",
    attrs: {
      "name": "pencil"
    }
  })], 1), _vm._v(" 待评价 "), _c('span')]), _c('div', {
    class: {
      'classSelect': _vm.projectDetail.project.participationstatus == 4
    }
  }, [_c('span'), _vm._v(" "), _c('p', [_c('icon', {
    staticClass: "icon",
    attrs: {
      "name": "thumbs-o-up"
    }
  })], 1), _vm._v(" 完成 ")])]), _vm._v(" "), (_vm.projectDetail.status === 'projectRecommend') ? _c('div', {
    staticClass: "recommendTitle"
  }, [_vm._v("推荐给我的项目")]) : _vm._e(), _vm._v(" "), (_vm.projectDetail.status === 'issue') ? _c('div', {
    staticClass: "recommendTitle"
  }, [_vm._v("我发布了这个项目")]) : _vm._e(), _vm._v(" "), (_vm.projectDetail.status === 'participation') ? _c('div', {
    staticClass: "my_job"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("我正在参与这个项目")]), _vm._v(" "), (false) ? _c('button', {
    staticClass: "sendBtn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("发送消息")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "bg_img",
    class: {
      'zhaomu': _vm.projectDetail.project.status == 4, 'close': _vm.projectDetail.project.status == 2, 'close1': _vm.projectDetail.project.status == 3, 'close2': _vm.projectDetail.project.status == 5, 'jinxing': _vm.projectDetail.project.status == 7, 'over': _vm.projectDetail.project.status == 8, 'hezuo': _vm.projectDetail.project.status == 6, 'pingjia': _vm.projectDetail.project.status == 9, 'shenhe': _vm.projectDetail.project.status == 1
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.projectDetail.project.title))]), _vm._v(" "), _c('span', {
    staticClass: "type"
  }, [_vm._v(_vm._s(_vm.projectDetail.project.projectType))]), _vm._v(" "), _c('span', {
    staticClass: "company"
  }, [_vm._v(_vm._s(_vm.projectDetail.project.companyName))]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm._f("formatDate")(_vm.projectDetail.project.createTime)))]), _vm._v(" "), _c('div', {
    staticClass: "cycle"
  }, [_c('div', {
    staticClass: "money"
  }, [_c('span', [_vm._v("项目预算")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.projectDetail.project.prePrice))])]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_c('span', [_vm._v("时间周期")]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.projectDetail.project.period))])])])]), _vm._v(" "), _c('div', {
    staticClass: "skills"
  }, _vm._l((_vm.projectDetail.SkillList), function(skillsList, index) {
    return _c('span', {
      key: index
    }, [_vm._v(_vm._s(skillsList.name))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "path"
  }, [_c('p', [_c('icon', {
    attrs: {
      "name": "suitcase"
    }
  }), _vm._v(" " + _vm._s(_vm.projectDetail.project.industry))], 1), _vm._v(" "), _c('p', [_c('icon', {
    attrs: {
      "name": "map-marker"
    }
  }), _vm._v(" " + _vm._s(_vm.projectDetail.project.city))], 1), _vm._v(" "), _c('p', [_c('icon', {
    attrs: {
      "name": "cogs"
    }
  }), _vm._v("\n        倾向接单\n        "), (_vm.projectDetail.project.enterType == 0) ? _c('span', [_vm._v("\n          没有倾向\n        ")]) : _vm._e(), _vm._v(" "), (_vm.projectDetail.project.enterType == 1) ? _c('span', [_vm._v("\n          个人\n        ")]) : _vm._e(), _vm._v(" "), (_vm.projectDetail.project.enterType == 2) ? _c('span', [_vm._v("\n          团队/工作室\n        ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "describe"
  }, [_c('p', [_vm._v("项目描述")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.projectDetail.project.description))])]), _vm._v(" "), (_vm.projectDetail.photoUrl.length > 0) ? _c('div', {
    staticClass: "img_describe"
  }, [_c('p', [_vm._v("图片说明")]), _vm._v(" "), _vm._l((_vm.projectDetail.photoUrl), function(imgurl, index) {
    return _c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (imgurl.fullPath),
        expression: "imgurl.fullPath"
      }],
      key: index
    })
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "people"
  }, [_c('div', {
    staticClass: "recommend"
  }, [_c('p', [_vm._v("已推荐 " + _vm._s(_vm.projectDetail.project.countRecommender) + " 人")]), _vm._v(" "), _c('div', _vm._l((_vm.recommendList), function(recommend, index) {
    return _c('span', {
      key: index
    }, [(recommend.photo) ? _c('img', {
      attrs: {
        "src": _vm.projectDetail.httpUrl + recommend.photo
      }
    }) : _vm._e(), _vm._v("\n            " + _vm._s(recommend.account.name) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "apply"
  }, [_c('p', [_vm._v("已申请 " + _vm._s(_vm.projectDetail.project.countOffer) + " 人")]), _vm._v(" "), _c('div', _vm._l((_vm.applyList), function(apply, index) {
    return _c('span', {
      key: index
    }, [(apply.photo) ? _c('img', {
      attrs: {
        "src": _vm.projectDetail.httpUrl + apply.photo
      }
    }) : _vm._e(), _vm._v("\n            " + _vm._s(apply.account.name) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "look"
  }, [_c('p', [_vm._v("已浏览 " + _vm._s(_vm.projectDetail.project.countVisit) + " 人")])])])]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [(_vm.projectDetail.project.status == 1 || _vm.projectDetail.project.status == 4) ? _c('div', {
    staticClass: "typeOne"
  }, [_c('span', {
    staticStyle: {
      "border-right": "1px solid #ccc"
    },
    on: {
      "click": function($event) {
        return _vm.toCloseProject(_vm.projectId, _vm.projectDetail.project.status)
      }
    }
  }, [_vm._v("关闭项目")]), _vm._v(" "), (_vm.projectDetail.project.status == 1) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.toModifyProject(_vm.projectId)
      }
    }
  }, [_vm._v("修改项目")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "recommendBtn",
    staticStyle: {
      "background-color": "#1663c9"
    },
    attrs: {
      "to": {
        path: '/project/recommendPeople',
        query: {
          projectId: _vm.projectId
        }
      }
    }
  }, [_vm._v("推荐的专家")]), _vm._v(" "), _c('router-link', {
    staticClass: "applyBtn",
    staticStyle: {
      "background-color": "#108ee9"
    },
    attrs: {
      "to": {
        path: '/project/applyPeople',
        query: {
          projectId: _vm.projectId
        }
      }
    }
  }, [_vm._v("申请的专家")])], 1) : _vm._e(), _vm._v(" "), (_vm.projectDetail.project.status == 6) ? _c('div', {
    staticClass: "typeTwo"
  }, [_vm._v("等待开工")]) : _vm._e(), _vm._v(" "), (_vm.projectDetail.project.status == 8) ? _c('div', {
    staticClass: "typeThree",
    on: {
      "click": function($event) {
        return _vm.toEvaluate()
      }
    }
  }, [_vm._v("给个评价")]) : _vm._e(), _vm._v(" "), (_vm.projectDetail.project.status == 9 && false) ? _c('div', {
    staticClass: "typeThree"
  }, [_vm._v("查看评价")]) : _vm._e()])], 1) : (_vm.projectDetail.status === 'projectRecommend') ? _c('div', {
    staticClass: "myProjectDetail"
  }, [_c('mt-header', {
    attrs: {
      "title": _vm.projectDetail.project.title
    }
  }, [_c('mt-button', {
    attrs: {
      "slot": "left",
      "icon": "back"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    },
    slot: "left"
  }, [_vm._v("返回")])], 1), _vm._v(" "), (_vm.projectDetail.status === 'projectRecommend') ? _c('div', {
    staticClass: "recommendTitle"
  }, [_vm._v("推荐给我的项目")]) : _vm._e(), _vm._v(" "), (_vm.projectDetail.status === 'issue') ? _c('div', {
    staticClass: "recommendTitle"
  }, [_vm._v("我发布了这个项目")]) : _vm._e(), _vm._v(" "), (_vm.projectDetail.status === 'projectOffer') ? _c('div', {
    staticClass: "recommendTitle"
  }, [_vm._v("我申请了这个项目")]) : _vm._e(), _vm._v(" "), (_vm.projectDetail.status === 'participation') ? _c('div', {
    staticClass: "my_job"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("我正在参与这个项目")]), _vm._v(" "), (false) ? _c('button', {
    staticClass: "sendBtn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("发送消息")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "bg_img",
    class: {
      'zhaomu': _vm.projectDetail.project.status == 4, 'close': _vm.projectDetail.project.status == 2, 'close1': _vm.projectDetail.project.status == 3, 'close2': _vm.projectDetail.project.status == 5, 'jinxing': _vm.projectDetail.project.status == 7, 'over': _vm.projectDetail.project.status == 8, 'hezuo': _vm.projectDetail.project.status == 6, 'pingjia': _vm.projectDetail.project.status == 9, 'shenhe': _vm.projectDetail.project.status == 1
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.projectDetail.project.title))]), _vm._v(" "), _c('span', {
    staticClass: "type"
  }, [_vm._v(_vm._s(_vm.projectDetail.project.projectType))]), _vm._v(" "), _c('span', {
    staticClass: "company"
  }, [_vm._v(_vm._s(_vm.projectDetail.project.companyName))]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm._f("formatDate")(_vm.projectDetail.project.createTime)))]), _vm._v(" "), _c('div', {
    staticClass: "cycle"
  }, [_c('div', {
    staticClass: "money"
  }, [_c('span', [_vm._v("项目预算")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.projectDetail.project.prePrice))])]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_c('span', [_vm._v("时间周期")]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.projectDetail.project.period))])])])]), _vm._v(" "), _c('div', {
    staticClass: "skills"
  }, _vm._l((_vm.projectDetail.SkillList), function(skillsList, index) {
    return _c('span', {
      key: index
    }, [_vm._v(_vm._s(skillsList.name))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "path"
  }, [_c('p', [_c('icon', {
    attrs: {
      "name": "suitcase"
    }
  }), _vm._v(" " + _vm._s(_vm.projectDetail.project.industry))], 1), _vm._v(" "), _c('p', [_c('icon', {
    attrs: {
      "name": "map-marker"
    }
  }), _vm._v(" " + _vm._s(_vm.projectDetail.project.city))], 1), _vm._v(" "), _c('p', [_c('icon', {
    attrs: {
      "name": "cogs"
    }
  }), _vm._v("\n        倾向接单\n        "), (_vm.projectDetail.project.enterType == 0) ? _c('span', [_vm._v("\n          没有倾向\n        ")]) : _vm._e(), _vm._v(" "), (_vm.projectDetail.project.enterType == 1) ? _c('span', [_vm._v("\n          个人\n        ")]) : _vm._e(), _vm._v(" "), (_vm.projectDetail.project.enterType == 2) ? _c('span', [_vm._v("\n          团队/工作室\n        ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "describe"
  }, [_c('p', [_vm._v("项目描述")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.projectDetail.project.description))])]), _vm._v(" "), (_vm.projectDetail.photoUrl.length > 0) ? _c('div', {
    staticClass: "img_describe"
  }, [_c('p', [_vm._v("图片说明")]), _vm._v(" "), _vm._l((_vm.projectDetail.photoUrl), function(imgurl, index) {
    return _c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (imgurl.fullPath),
        expression: "imgurl.fullPath"
      }],
      key: index
    })
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "people"
  }, [_c('div', {
    staticClass: "recommend"
  }, [_c('p', [_vm._v("已推荐 " + _vm._s(_vm.projectDetail.project.countRecommender) + " 人")]), _vm._v(" "), _c('div', _vm._l((_vm.recommendList), function(recommend, index) {
    return _c('span', {
      key: index
    }, [(recommend.photo) ? _c('img', {
      attrs: {
        "src": _vm.projectDetail.httpUrl + recommend.photo
      }
    }) : _vm._e(), _vm._v("\n            " + _vm._s(recommend.account.name) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "apply"
  }, [_c('p', [_vm._v("已申请 " + _vm._s(_vm.projectDetail.project.countOffer) + " 人")]), _vm._v(" "), _c('div', _vm._l((_vm.applyList), function(apply, index) {
    return _c('span', {
      key: index
    }, [(apply.photo) ? _c('img', {
      attrs: {
        "src": _vm.projectDetail.httpUrl + apply.photo
      }
    }) : _vm._e(), _vm._v("\n            " + _vm._s(apply.account.name) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "look"
  }, [_c('p', [_vm._v("已浏览 " + _vm._s(_vm.projectDetail.project.countVisit) + " 人")])])])]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [(_vm.projectDetail.project.status == 4) ? _c('div', {
    staticClass: "typeThree",
    on: {
      "click": function($event) {
        return _vm.sendApply(_vm.projectDetail.project)
      }
    }
  }, [_vm._v("发送意向")]) : _vm._e()])], 1) : (_vm.projectDetail.status === 'issue') ? _c('div', {
    staticClass: "myProjectDetail"
  }, [_c('mt-header', {
    attrs: {
      "title": _vm.projectDetail.project.title
    }
  }, [_c('mt-button', {
    attrs: {
      "slot": "left",
      "icon": "back"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    },
    slot: "left"
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "step"
  }, [_c('div', {
    class: {
      'classSelect': _vm.projectDetail.project.pathwaystatus == 0 || _vm.projectDetail.project.pathwaystatus == 1 || _vm.projectDetail.project.pathwaystatus == 2 || _vm.projectDetail.project.pathwaystatus == 3 || _vm.projectDetail.project.pathwaystatus == 4 || _vm.projectDetail.project.pathwaystatus == 5
    }
  }, [_c('p', [_c('icon', {
    staticClass: "icon",
    attrs: {
      "name": "globe"
    }
  })], 1), _vm._v(" 招募中 "), _c('span')]), _vm._v(" "), _c('div', {
    class: {
      'classSelect': _vm.projectDetail.project.pathwaystatus == 1 || _vm.projectDetail.project.pathwaystatus == 2 || _vm.projectDetail.project.pathwaystatus == 3 || _vm.projectDetail.project.pathwaystatus == 4 || _vm.projectDetail.project.pathwaystatus == 5
    }
  }, [_c('span'), _vm._v(" "), _c('p', [_c('icon', {
    staticClass: "icon",
    attrs: {
      "name": "handshake-o"
    }
  })], 1), _vm._v(" 雇佣并付款 "), _c('span')]), _vm._v(" "), _c('div', {
    class: {
      'classSelect': _vm.projectDetail.project.pathwaystatus == 2 || _vm.projectDetail.project.pathwaystatus == 3 || _vm.projectDetail.project.pathwaystatus == 4 || _vm.projectDetail.project.pathwaystatus == 5
    }
  }, [_c('span'), _vm._v(" "), _c('p', [_c('icon', {
    staticClass: "icon",
    attrs: {
      "name": "hourglass-half"
    }
  })], 1), _vm._v(" 进行中 "), _c('span')]), _vm._v(" "), _c('div', {
    class: {
      'classSelect': _vm.projectDetail.project.pathwaystatus == 3 || _vm.projectDetail.project.pathwaystatus == 4 || _vm.projectDetail.project.pathwaystatus == 5
    }
  }, [_c('span'), _vm._v(" "), _c('p', [_c('icon', {
    staticClass: "icon",
    attrs: {
      "name": "shopping-bag"
    }
  })], 1), _vm._v(" 待验收 "), _c('span')]), _vm._v(" "), _c('div', {
    class: {
      'classSelect': _vm.projectDetail.project.pathwaystatus == 4 || _vm.projectDetail.project.pathwaystatus == 5
    }
  }, [_c('span'), _vm._v(" "), _c('p', [_c('icon', {
    staticClass: "icon",
    attrs: {
      "name": "pencil"
    }
  })], 1), _vm._v(" 待评价 "), _c('span')]), _vm._v(" "), _c('div', {
    class: {
      'classSelect': _vm.projectDetail.project.pathwaystatus == 5
    }
  }, [_c('span'), _vm._v(" "), _c('p', [_c('icon', {
    staticClass: "icon",
    attrs: {
      "name": "thumbs-o-up"
    }
  })], 1), _vm._v(" 完成 \n    ")])]), _vm._v(" "), (_vm.projectDetail.project.status == 6 || _vm.projectDetail.project.status == 7 || _vm.projectDetail.project.status == 8 || _vm.projectDetail.project.status == 9) ? _c('div', {
    staticClass: "talk"
  }, [_c('img', {
    attrs: {
      "src": _vm.projectDetail.imageUrl
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_c('span', [_vm._v(_vm._s(_vm.projectDetail.name))]), _vm._v("正在进行项目")]), _vm._v(" "), (false) ? _c('button', {
    staticClass: "sendBtn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("发送消息")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "bg_img",
    class: {
      'zhaomu': _vm.projectDetail.project.status == 4, 'close': _vm.projectDetail.project.status == 2, 'close1': _vm.projectDetail.project.status == 3, 'close2': _vm.projectDetail.project.status == 5, 'jinxing': _vm.projectDetail.project.status == 7, 'over': _vm.projectDetail.project.status == 8, 'hezuo': _vm.projectDetail.project.status == 6, 'pingjia': _vm.projectDetail.project.status == 9, 'shenhe': _vm.projectDetail.project.status == 1
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.projectDetail.project.title))]), _vm._v(" "), _c('span', {
    staticClass: "type"
  }, [_vm._v(_vm._s(_vm.projectDetail.project.projectType))]), _vm._v(" "), _c('span', {
    staticClass: "company"
  }, [_vm._v(_vm._s(_vm.projectDetail.project.companyName))]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm._f("formatDate")(_vm.projectDetail.project.createTime)))]), _vm._v(" "), _c('div', {
    staticClass: "cycle"
  }, [_c('div', {
    staticClass: "money"
  }, [_c('span', [_vm._v("项目预算")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.projectDetail.project.prePrice))])]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_c('span', [_vm._v("时间周期")]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.projectDetail.project.period))])])])]), _vm._v(" "), _c('div', {
    staticClass: "skills"
  }, _vm._l((_vm.projectDetail.SkillList), function(skillsList, index) {
    return _c('span', {
      key: index
    }, [_vm._v(_vm._s(skillsList.name))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "path"
  }, [_c('p', [_c('icon', {
    attrs: {
      "name": "suitcase"
    }
  }), _vm._v(" " + _vm._s(_vm.projectDetail.project.industry))], 1), _vm._v(" "), _c('p', [_c('icon', {
    attrs: {
      "name": "map-marker"
    }
  }), _vm._v(" " + _vm._s(_vm.projectDetail.project.city))], 1), _vm._v(" "), _c('p', [_c('icon', {
    attrs: {
      "name": "cogs"
    }
  }), _vm._v(" \n        倾向接单\n        "), (_vm.projectDetail.project.enterType == 0) ? _c('span', [_vm._v("\n          没有倾向\n        ")]) : _vm._e(), _vm._v(" "), (_vm.projectDetail.project.enterType == 1) ? _c('span', [_vm._v("\n          个人\n        ")]) : _vm._e(), _vm._v(" "), (_vm.projectDetail.project.enterType == 2) ? _c('span', [_vm._v("\n          团队/工作室\n        ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "describe"
  }, [_c('p', [_vm._v("项目描述")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.projectDetail.project.description))])]), _vm._v(" "), (_vm.projectDetail.photoUrl.length > 0) ? _c('div', {
    staticClass: "img_describe"
  }, [_c('p', [_vm._v("图片说明")]), _vm._v(" "), _vm._l((_vm.projectDetail.photoUrl), function(imgurl, index) {
    return _c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (imgurl.fullPath),
        expression: "imgurl.fullPath"
      }],
      key: index
    })
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "people"
  }, [_c('div', {
    staticClass: "recommend"
  }, [_c('p', [_vm._v("已推荐 " + _vm._s(_vm.projectDetail.project.countRecommender) + " 人")]), _vm._v(" "), _c('div', _vm._l((_vm.recommendList), function(recommend, index) {
    return _c('span', {
      key: index
    }, [(recommend.photo) ? _c('img', {
      attrs: {
        "src": _vm.projectDetail.httpUrl + recommend.photo
      }
    }) : _vm._e(), _vm._v("\n            " + _vm._s(recommend.account.name) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "apply"
  }, [_c('p', [_vm._v("已申请 " + _vm._s(_vm.projectDetail.project.countOffer) + " 人")]), _vm._v(" "), _c('div', _vm._l((_vm.applyList), function(apply, index) {
    return _c('span', {
      key: index
    }, [(apply.photo) ? _c('img', {
      attrs: {
        "src": _vm.projectDetail.httpUrl + apply.photo
      }
    }) : _vm._e(), _vm._v("\n            " + _vm._s(apply.account.name) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "look"
  }, [_c('p', [_vm._v("已浏览 " + _vm._s(_vm.projectDetail.project.countVisit) + " 人")])])])]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [(_vm.projectDetail.project.status == 1 || _vm.projectDetail.project.status == 4) ? _c('div', {
    staticClass: "typeOne"
  }, [_c('span', {
    staticStyle: {
      "border-right": "1px solid #ccc"
    },
    on: {
      "click": function($event) {
        return _vm.toCloseProject(_vm.projectId, _vm.projectDetail.project.status)
      }
    }
  }, [_vm._v("关闭项目")]), _vm._v(" "), (_vm.projectDetail.project.status == 1) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.toModifyProject(_vm.projectId)
      }
    }
  }, [_vm._v("修改项目")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "recommendBtn",
    staticStyle: {
      "background-color": "#1663c9"
    },
    attrs: {
      "to": {
        path: '/project/recommendPeople',
        query: {
          projectId: _vm.projectId
        }
      }
    }
  }, [_vm._v("推荐的专家")]), _vm._v(" "), _c('router-link', {
    staticClass: "applyBtn",
    staticStyle: {
      "background-color": "#108ee9"
    },
    attrs: {
      "to": {
        path: '/project/applyPeople',
        query: {
          projectId: _vm.projectId
        }
      }
    }
  }, [_vm._v("申请的专家")])], 1) : _vm._e(), _vm._v(" "), (_vm.projectDetail.project.status == 6) ? _c('div', {
    staticClass: "typeTwo"
  }, [_vm._v("等待开工")]) : _vm._e(), _vm._v(" "), (_vm.projectDetail.project.status == 7) ? _c('div', {
    staticClass: "typeThree",
    on: {
      "click": function($event) {
        return _vm.finishPeoject(_vm.projectId, _vm.projectDetail.project)
      }
    }
  }, [_vm._v("确认验收")]) : _vm._e(), _vm._v(" "), (_vm.projectDetail.project.status == 8) ? _c('div', {
    staticClass: "typeThree",
    on: {
      "click": function($event) {
        return _vm.toEvaluate()
      }
    }
  }, [_vm._v("给个评价")]) : _vm._e(), _vm._v(" "), (_vm.projectDetail.project.status == 9 && false) ? _c('div', {
    staticClass: "typeThree"
  }, [_vm._v("查看评价")]) : _vm._e()])], 1) : (_vm.projectDetail.status === 'projectOffer') ? _c('div', {
    staticClass: "myProjectDetail"
  }, [_c('mt-header', {
    attrs: {
      "title": _vm.projectDetail.project.title
    }
  }, [_c('mt-button', {
    attrs: {
      "slot": "left",
      "icon": "back"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    },
    slot: "left"
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "letter"
  }, [_c('p', {
    staticClass: "letter_title"
  }, [_vm._v("我申请了这个项目")]), _vm._v(" "), _c('h1', [_vm._v("申请信")]), _vm._v(" "), _c('p', {
    staticClass: "letter_money"
  }, [_vm._v("我的报价： ¥"), _c('strong', [_vm._v(_vm._s(_vm.projectDetail.projectOffer.price))])]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.projectDetail.projectOffer.content))])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "bg_img",
    class: {
      'zhaomu': _vm.projectDetail.project.status == 4, 'close': _vm.projectDetail.project.status == 2, 'close1': _vm.projectDetail.project.status == 3, 'close2': _vm.projectDetail.project.status == 5, 'jinxing': _vm.projectDetail.project.status == 7, 'over': _vm.projectDetail.project.status == 8, 'hezuo': _vm.projectDetail.project.status == 6, 'pingjia': _vm.projectDetail.project.status == 9, 'shenhe': _vm.projectDetail.project.status == 1
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.projectDetail.project.title))]), _vm._v(" "), _c('span', {
    staticClass: "type"
  }, [_vm._v(_vm._s(_vm.projectDetail.project.projectType))]), _vm._v(" "), _c('span', {
    staticClass: "company"
  }, [_vm._v(_vm._s(_vm.projectDetail.project.companyName))]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm._f("formatDate")(_vm.projectDetail.project.createTime)))]), _vm._v(" "), _c('div', {
    staticClass: "cycle"
  }, [_c('div', {
    staticClass: "money"
  }, [_c('span', [_vm._v("项目预算")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.projectDetail.project.prePrice))])]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_c('span', [_vm._v("时间周期")]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.projectDetail.project.period))])])])]), _vm._v(" "), _c('div', {
    staticClass: "skills"
  }, _vm._l((_vm.projectDetail.SkillList), function(skillsList, index) {
    return _c('span', {
      key: index
    }, [_vm._v(_vm._s(skillsList.name))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "path"
  }, [_c('p', [_c('icon', {
    attrs: {
      "name": "suitcase"
    }
  }), _vm._v(" " + _vm._s(_vm.projectDetail.project.industry))], 1), _vm._v(" "), _c('p', [_c('icon', {
    attrs: {
      "name": "map-marker"
    }
  }), _vm._v(" " + _vm._s(_vm.projectDetail.project.city))], 1), _vm._v(" "), _c('p', [_c('icon', {
    attrs: {
      "name": "cogs"
    }
  }), _vm._v("\n        倾向接单\n        "), (_vm.projectDetail.project.enterType == 0) ? _c('span', [_vm._v("\n          没有倾向\n        ")]) : _vm._e(), _vm._v(" "), (_vm.projectDetail.project.enterType == 1) ? _c('span', [_vm._v("\n          个人\n        ")]) : _vm._e(), _vm._v(" "), (_vm.projectDetail.project.enterType == 2) ? _c('span', [_vm._v("\n          团队/工作室\n        ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "describe"
  }, [_c('p', [_vm._v("项目描述")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.projectDetail.project.description))])]), _vm._v(" "), (_vm.projectDetail.photoUrl.length > 0) ? _c('div', {
    staticClass: "img_describe"
  }, [_c('p', [_vm._v("图片说明")]), _vm._v(" "), _vm._l((_vm.projectDetail.photoUrl), function(imgurl, index) {
    return _c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (imgurl.fullPath),
        expression: "imgurl.fullPath"
      }],
      key: index
    })
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "people"
  }, [_c('div', {
    staticClass: "recommend"
  }, [_c('p', [_vm._v("已推荐 " + _vm._s(_vm.projectDetail.project.countRecommender) + " 人")]), _vm._v(" "), _c('div', _vm._l((_vm.recommendList), function(recommend, index) {
    return _c('span', {
      key: index
    }, [(recommend.photo) ? _c('img', {
      attrs: {
        "src": _vm.projectDetail.httpUrl + recommend.photo
      }
    }) : _vm._e(), _vm._v("\n            " + _vm._s(recommend.account.name) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "apply"
  }, [_c('p', [_vm._v("已申请 " + _vm._s(_vm.projectDetail.project.countOffer) + " 人")]), _vm._v(" "), _c('div', _vm._l((_vm.applyList), function(apply, index) {
    return _c('span', {
      key: index
    }, [(apply.photo) ? _c('img', {
      attrs: {
        "src": _vm.projectDetail.httpUrl + apply.photo
      }
    }) : _vm._e(), _vm._v("\n            " + _vm._s(apply.account.name) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "look"
  }, [_c('p', [_vm._v("已浏览 " + _vm._s(_vm.projectDetail.project.countVisit) + " 人")])])])]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [(_vm.projectDetail.project.status == 4) ? _c('div', {
    staticClass: "typeTwo"
  }, [_vm._v("项目正在招募中...")]) : _vm._e()])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30fc09f4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/myProjectDetail.vue
// module id = 1269
// module chunks = 1